import { render, staticRenderFns } from "./priceDistro.vue?vue&type=template&id=ae767a84&scoped=true&"
import script from "./priceDistro.vue?vue&type=script&lang=js&"
export * from "./priceDistro.vue?vue&type=script&lang=js&"
import style0 from "./priceDistro.vue?vue&type=style&index=0&id=ae767a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae767a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VLayout})
